    // src/components/Layout.js
    import React from 'react';
    import { Outlet } from 'react-router-dom';
    import { Box, Container, CssBaseline } from '@mui/material';
    import AppBar from './AppBar';
    import Drawer from './Drawer';

    const drawerWidth = 240;
    const Layout = () => {
    const [open, setOpen] = React.useState(true);

    const toggleDrawer = () => {
        setOpen(!open);
    };

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar open={open} toggleDrawer={toggleDrawer} />
            <Drawer open={open} toggleDrawer={toggleDrawer} />
            <Box
                component="main"
                sx={{
                flexGrow: 1,
                p: 3,
                minHeight: '100vh',
                backgroundColor: 'background.default',
                transition: theme => theme.transitions.create('margin', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,

                }),
                marginLeft: theme => `-${drawerWidth}px`,
                ...(open && {
                    transition: theme => theme.transitions.create('margin', {
                    easing: theme.transitions.easing.easeOut,
                    duration: theme.transitions.duration.enteringScreen,
                    }),
                    marginLeft: 0,
                }),
                }}
            >
                <Container maxWidth="xl" sx={{ py: 3 }}>
                <Outlet />
                </Container>
            </Box>
        </Box>
    );
    };

    export default Layout;